<template> 

    <v-container>
            <v-layout row justify-center>
                <v-flex lg12 xs12  class="px-1 py-lg-0  mt-0">
                    <v-layout row justify-center>
                            <section class="bar-graph bar-graph-vertical bar-graph-two">
                            <v-flex>
                                <div :class="StudentData.level==1 ? ' bar-one bar-container active-bar':' bar-one bar-container'">
                                    <div class="bar"></div>
                                    
                                </div>
                                <div :class="StudentData.level==2 ? ' bar-two bar-container active-bar':' bar-two bar-container'">
                                    <div class="bar" ></div>
                                    
                                </div>
                                <div :class="StudentData.level==3 ? ' bar-three bar-container active-bar':' bar-three bar-container'">
                                    <div class="bar" > </div>
                                   
                                </div>
                                <div :class="StudentData.level==4 ? ' bar-four bar-container active-bar':' bar-four bar-container'">
                                    <div class="bar"></div>
                                    
                                </div>
                                <div :class="StudentData.level==5 ? ' bar-five bar-container active-bar':' bar-five bar-container'">
                                    <div class="bar" ></div>
                                    
                                </div>
                                <div :class="StudentData.level==6 ? ' bar-six bar-container active-bar':' bar-six bar-container'">
                                    <div class="bar"></div>
                                    
                                </div>
                                <div :class="StudentData.level==7 ? ' bar-seven bar-container active-bar':' bar-seven bar-container'">
                                    <div class="bar"></div>
                                    
                                </div>
                                <div :class="StudentData.level==8 ? ' bar-eight bar-container active-bar':' bar-eight bar-container'">
                                    <div class="bar"></div>
                                    
                                </div>
                                <div :class="StudentData.level==9 ? ' bar-nine bar-container active-bar':' bar-nine bar-container'">
                                    <div class="bar" ></div>
                                    
                                </div>
                                <div :class="StudentData.level==10 ? ' bar-ten bar-container active-bar':' bar-ten bar-container'">
                                    <div class="bar"></div>
                                    
                                </div>
                            </v-flex>
                            <v-flex class="text-center text-md-body-1 text-lg-h5 font-weight-medium circle-chart__info white--text">
                                        <!-- <p> Level {{StudentData.level}}</p> -->
                                        <p> {{scoreLevel(StudentData.level)}} </p>
                            </v-flex>
                         </section>
                    </v-layout>
                </v-flex>

            </v-layout>
    </v-container>
    
            



</template>
<script>
import Vue from 'vue'
import axios from 'axios'

import VueAxios from 'vue-axios'
Vue.use(VueAxios,axios)
export default {
    name: 'BarChart',
   data:()=>{
        return{
            StudentData: '',
        }
    },
    mounted(){
     
        axios.get('https://phone.megatalking.com/origin/api/leveltest_evaluation.php?l_id='+this.$route.params.l_id+'&action=levelResult')
        // .then(response=>console.warn(response.data))
        .then((response)=>{this.StudentData=response.data.evaluation})
        // this.word1()
        // this.word2()
       
    },
    methods:{
        scoreLevel: function(val){
            if (val == 1) {
                return "Low Beginner"
            } else if (val == 2) {
                return "Beginner"
            } else if (val == 3) {
                return "High Beginner"
            } else if (val == 4) {
                return "Low Intermediate"
            } else if (val == 5) {
                return  "Intermediate"
            } else if (val == 6) {
                return  "High Intermediate"
            } else if (val == 7) {
                return "Pre Advanced"
            } else if (val == 8) {
                return  "Advanced"
            } else if (val ==9) {
                return "Post Advanced"
            } else {
                return " Undefined Level"
            }
        },
        
    }
}
</script>
<style scoped>
@import '../../../../src/assets/css/LevelTest/barchartnew.css';
</style>